export default "__VITE_ASSET__DeX6$94D__"